// extracted by mini-css-extract-plugin
export var hrEducational = "index-module--hrEducational--840db";
export var hrMarketable = "index-module--hrMarketable--978f2";
export var mastheadH1 = "index-module--mastheadH1--231fd";
export var moreSection = "index-module--moreSection--ef7de";
export var moreTextNoBorderEducational = "index-module--moreTextNoBorderEducational--f701d";
export var moreTextNoBorderExperienceThePower = "index-module--moreTextNoBorderExperienceThePower--34069";
export var moreTextNoBorderMarketable = "index-module--moreTextNoBorderMarketable--96b7a";